import React from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import TalosCapabilities from "@/components/site/TalosCapabilities";
import AIWorkflows from "@/components/site/AIWorkflows";
import Showcase from "@/components/site/Showcase";
import Differentiators from "@/components/site/Differentiators";
import AccountingExpert from "@/components/site/AccountingExpert";
import Pricing from "@/components/site/Pricing";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import TalosChat from "@/components/site/TalosChat";
import { ThemeProvider } from "@/components/site/ThemeProvider";

export default function Landing() {
  return (
    <ThemeProvider>
      <div
        className="bg-white transition-colors duration-500 dark:bg-navy-950"
        data-testid="landing-page"
      >
        <Navbar />
        <main>
          <Hero />
          <Features />
          <TalosCapabilities />
          <AIWorkflows />
          <Showcase />
          <Differentiators />
          <AccountingExpert />
          <Pricing />
          <FAQ />
        </main>

        <FinalCTA />
        <TalosChat />
        <Toaster position="top-right" richColors />
      </div>
    </ThemeProvider>
  );
}
